import { useMutation, useQueryClient } from "@tanstack/react-query";
import { fetchWithCsrf } from "@/lib/api";
import { useNavigate } from "react-router";
import { CURRENT_USER_QUERY_KEY } from "./useCurrentUser";

export function useLogout() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return useMutation({
    mutationFn: async () => {
      return fetchWithCsrf("/api/session", { method: "DELETE" });
    },
    onSuccess: () => {
      queryClient.setQueryData(CURRENT_USER_QUERY_KEY, null);
      navigate("/login");
    },
  });
}
